import {wx_share} from '../api/Interface'
import wx from 'weixin-js-sdk'
import {mapState} from 'vuex'
let wxconfig={
    data(){
        return {
            shareImg:"https://cloudforms.cjyun.org/cloudform.jpg"
        }
    },
    computed: {
        ...mapState(['settingData', 'formId'])
    },
    mounted() {

    },
    methods:{
        getwxconfig(callback) {
            let shareParam = {
                form_id: this.$route.query.id,
                share_url: location.href.split('#')[0]
                // share_url:location.origin
            }
            wx_share(shareParam).then(res => {
                if (res.state) {
                    console.log(res);
                    wx.config({
                        debug: false,   // 代码调试的时候写true
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: [
                            'onMenuShareTimeline',  // 分享给好友
                            'onMenuShareAppMessage', // 分享到朋友圈
                            'onMenuShareQQ',  // 分享到QQ
                            'onMenuShareWeibo' // 分享到微博
                        ]
                    })
                    if(callback) callback();
                    wx.error(res => {
                        console.log(res);
                    })
                }
            }).catch(error => {
                console.log(error)
            })
        },
        wxready(wechat){
            var _this = this;
            wx.ready(function () {
                //分享到朋友圈
                wx.onMenuShareTimeline({
                    title: wechat.title, // 分享标题
                    link: wechat.link, // 分享链接
                    imgUrl: wechat.imgUrl?wechat.imgUrl:_this.shareImg, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                //获取“分享给朋友”按钮点击状态及自定义分享内容接口
                wx.onMenuShareAppMessage({
                    title: wechat.title, // 分享标题
                    desc: wechat.desc, // 分享描述
                    link: wechat.link, // 分享链接
                    imgUrl: wechat.imgUrl?wechat.imgUrl:_this.shareImg, // 分享图标,注意图标宽高要大于300px
                    type: '', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    },
                    fail: function (res) {
//                    alert("分享失败：" +JSON.stringify(res));
                        console.log("分享失败：" + JSON.stringify(res));
                    }
                });
                //获取“分享到QQ”按钮点击状态及自定义分享内容接口
                wx.onMenuShareQQ({
                    title: wechat.title, // 分享标题
                    desc: wechat.desc, // 分享描述
                    link: wechat.link, // 分享链接
                    imgUrl: wechat.imgUrl?wechat.imgUrl:_this.shareImg, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                //获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
                wx.onMenuShareWeibo({
                    title: wechat.title, // 分享标题
                    desc: wechat.desc, // 分享描述
                    link: wechat.link, // 分享链接
                    imgUrl: wechat.imgUrl?wechat.imgUrl:_this.shareImg, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                //获取“分享到QQ空间”按钮点击状态及自定义分享内容接口
                wx.onMenuShareQZone({
                    title: wechat.title, // 分享标题
                    desc: wechat.desc, // 分享描述
                    link: wechat.link, // 分享链接
                    imgUrl: wechat.imgUrl?wechat.imgUrl:_this.shareImg, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
            });
        },
        hideShareMenu(){
            wx.ready(()=>{
                wx.hideMenuItems({
                    menuList: [
                        'menuItem:share:appMessage',
                        'menuItem:share:timeline',
                        'menuItem:share:qq',
                        'menuItem:share:weiboApp',
                        'menuItem:share:facebook',
                        'menuItem:share:QZone'
                    ]
                })
                wx.hideOptionMenu()
            })
        }
    }
}

export default wxconfig;